module.exports = __webpack_public_path__ + "img/1004.73ebd82f.png";